import React from "react";
import tvgConf from "@tvg/conf";
import DepositsMask from "../../../Masks/depositsMask";
import DesktopDepositMask from "../../../Masks/desktopDepositMask";

const LoadingMask = () =>
  tvgConf().device === "desktop" ? <DesktopDepositMask /> : <DepositsMask />;

export default LoadingMask;
